module.exports = __webpack_public_path__ + "img/slolution-1.d90e6d5.png";